import { MarkedOptions, MarkedRenderer } from 'ngx-markdown';

// function that returns `MarkedOptions` with renderer override
export function markedOptionsFactory(): MarkedOptions {
  const renderer = new MarkedRenderer();

  renderer.link = (href: string, title: string, text: string) => {
    let returnLink = text !== null ? text : '';
    if (href !== null && text !== null) {
      if (href.includes('http')) {
        returnLink = '<a href="' + href + '" target="_blank">' + text + '</a>';
      } else {
        returnLink = '<a href="' + href + '">' + text + '</a>';
      }
    }

    // console.log('markedOptionsFactory.renderer.link :: returnLink = ' + returnLink);

    return returnLink;
  };

  return {
    renderer: renderer,
    gfm: true,
    breaks: false,
    pedantic: false,
    smartLists: true,
    smartypants: false
  };
}
